var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1077_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 12.55 18.45 13 19 13H21C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11H19C18.45 11 18 11.45 18 12Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59 16.8199C16.26 17.2599 16.35 17.8699 16.79 18.1899C17.32 18.5799 17.88 18.9999 18.41 19.3999C18.85 19.7299 19.47 19.6399 19.79 19.1999C19.79 19.1899 19.8 19.1899 19.8 19.1799C20.13 18.7399 20.04 18.1199 19.6 17.7999C19.07 17.3999 18.51 16.9799 17.99 16.5899C17.55 16.2599 16.93 16.3599 16.6 16.7999C16.6 16.8099 16.59 16.8199 16.59 16.8199Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.81 4.81004C19.81 4.80004 19.8 4.80004 19.8 4.79004C19.47 4.35004 18.85 4.26005 18.42 4.59005C17.89 4.99005 17.32 5.41004 16.8 5.81004C16.36 6.14004 16.28 6.76005 16.61 7.19005C16.61 7.20005 16.62 7.20005 16.62 7.21005C16.95 7.65005 17.56 7.74004 18 7.41004C18.53 7.02004 19.09 6.59004 19.62 6.19004C20.05 5.87004 20.13 5.25004 19.81 4.81004Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9H4C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18V15H8L13 18V6L8 9Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.9999C15.5 10.6699 14.92 9.4699 14 8.6499V15.3399C14.92 14.5299 15.5 13.3299 15.5 11.9999Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1077_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementMenuIcon);
export default __webpack_public_path__ + "static/media/AnnouncementMenuIcon.34437421bac0c520bd7ae3093b2f7d95.svg";
export { ForwardRef as ReactComponent };